import { Link } from "react-router-dom";

/** The one wording used wherever someone would otherwise create an account. */
export function AccountsClosedMessage(): JSX.Element {
  return (
    <>
      Creating an account is temporarily closed. Please contact{" "}
      <Link to="/about#authors">Dr. Kadir Kozan</Link> or <Link to="/about#authors">Dr. Jean Baptiste Mbanzabugabo</Link> for
      account verification. You don't need an account to use EduFadder.
    </>
  );
}
